import { ResourceType } from '../../Entities/ResourceType';
import * as DateEx from '../../Utilities/DateEx';
import { ContractWithStringVariants, UnitType } from '../../api/generated/data-contracts';
import { ProjectType } from '../../Entities/ProjectType';
import { fieldOptionsFactory, IFormSchema } from 'spark-forms';
import { systemFieldsGrouped, tpFieldOptionsFactory } from '../_builders/new/tpFieldOptionsFactory';
import { OriginRender } from '../_builders/new/components/OriginRender';
import { UnitTypeUtil } from '../../Utilities/UnitTypeUtil';
import { merge } from '../../helpers/merge';
import { getcustomPropertiesSchema } from '../../components_new/customPropertiesSchema';
import { translate } from '../../Locales/i18n/localizationService';

const activitiesText = (unitType: UnitType = UnitTypeUtil.getCurrentUnitType()) => {
	return unitType === UnitType.FTE
		? 'average'
		: 'sum';
}

const activitiesDescription = (unitType: UnitType = UnitTypeUtil.getCurrentUnitType()) => {
	return unitType === UnitType.FTE
		? 'The FTE work as an average within start and end of the contract'
		: 'The total hours on the contract';
}

export const getContractSchema = (unitType: UnitType) : IFormSchema<ContractWithStringVariants> => {
	return merge(contractSchema, { fields: {
		requestsAsString: {
			displayName: `Requests ${activitiesText(unitType)}`, //TODO: language
			description: activitiesDescription(unitType),
		},
		allocationsAsString: {
			displayName: `Allocations ${activitiesText(unitType)}`, //TODO: language
			description: activitiesDescription(unitType),
		}
	}})
}

export const contractSchema: IFormSchema<ContractWithStringVariants> = {
	groups: {
		basic: { displayName: 'Basic', groupProps: { icon: 'EntitlementPolicy', selected: true } },
		customProperties: { displayName: 'Custom properties', groupProps: { icon: 'DataManagementSettings' } },
		activities: { displayName: 'Activities', groupProps: { icon: 'Permissions' } },
		system: { displayName: 'System', groupProps: { icon: 'Settings' } }
	},
	fields: {
		name: fieldOptionsFactory.string({
			displayName: translate.t("Common.Name"),
			group: 'basic',
			disable: () => true,
		}),
		projectId: tpFieldOptionsFactory.project({
			displayName: translate.t("Common.Project"),
			group: 'basic',
			config: {
				nameField: 'name',
				descriptionField: 'owner',
				pickerType: 'tag',
				projectTypes: [ProjectType.Default, ProjectType.Administrative, ProjectType.Team],
			},
			disable: () => true,
		}),
		resourceGuid: tpFieldOptionsFactory.resource({
			displayName: 'Resource', //TODO: language
			group: 'basic',
			config: {
				nameField: 'name',
				descriptionField: 'email',
				resourceTypes: [ResourceType.Named, ResourceType.Generic, ResourceType.Pool, ResourceType.Team, ResourceType.Category],
			},
			disable: () => true,
		}),
		// fake it, cause it's easy :)
		rbsAsString: fieldOptionsFactory.string({
			displayName: 'RBS', //TODO: language
			group: 'basic',
			disable: () => true,
		}),
		start: fieldOptionsFactory.date({
			displayName: translate.t("Common.Start"),
			group: 'basic',
			disable: () => true,
			config: { displayFormat: (date?: Date) => DateEx.asUserLocalWithTime(date) },
		}),
		end: fieldOptionsFactory.date({
			displayName: translate.t("Common.End"),
			group: 'basic',
			config: { displayFormat: (date?: Date) => DateEx.asUserLocalWithTime(date) },
			disable: () => true,
		}),
		workPackage: fieldOptionsFactory.string({
			displayName: translate.t("Common.WorkPackage"),
			group: 'basic',
			disable: () => true,
		}),
		// fake it, cause it's easy :)
		requestsAsString: fieldOptionsFactory.string({
			displayName: `Requests ${activitiesText()}`, //TODO: language
			description: activitiesDescription(),
			group: 'activities',
			disable: () => true,
		}),
		// fake it, cause it's easy :)
		allocationsAsString: fieldOptionsFactory.string({
			displayName: `Allocations ${activitiesText()}`, //TODO: language
			description: activitiesDescription(),
			group: 'activities',
			disable: () => true,
		}),
		// is this really relevant? (ewi)
		// proposedWorkAsString: fieldOptionsFactory.string({
		// 	displayName: 'ProposedWork', //TODO: language
		// 	group: 'activities',
		// 	disable: () => true,
		// }),
		// fake it, cause it's easy :)string
		// this is quick and dirty - for use in list column (ewi)
		alignStatus: fieldOptionsFactory.string({
			displayName: 'Contract status', //TODO: language
			group: 'basic',
			hide: () => true
		}),
		// this is quick and dirty - for use in form (ewi)
		alignStatusAsString: fieldOptionsFactory.string({
			displayName: 'Contract status', //TODO: language
			group: 'basic',
			disable: () => true
		}),
		// fake it, cause it's easy :)string
		sourceActionAsString: fieldOptionsFactory.string({
			displayName: 'Source action', //TODO: language
			group: 'system',
			disable: () => true,
		}),
		// TODO: we need support for groupings in nested formitems, in spark-forms (ewi)
		customProperties: fieldOptionsFactory.formItem({
            displayName: translate.t("Common.CustomPropertiesCapitalized"),
			group: 'customProperties',
			description: 'Custom properties',
            config: {
                schema: {
                    schemaProvider: () => getcustomPropertiesSchema('contract', () => true)
                },
            },
            disable: () => true,
        }),

		origins: fieldOptionsFactory.customComponent({
			displayName: translate.t("Common.Origins"),
			group: 'system',
			disable: () => true,
			config: { component: OriginRender },
		}),

		...systemFieldsGrouped(),
	}
};
